import { Component, OnInit, Input, Output, EventEmitter, OnChanges, ViewChild } from '@angular/core';
import { CommonService } from '../services/common.service';
import { HighlightPipe } from '../autocomplete/autocomplete.component';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import moment from 'moment';
import { BehaviorSubject } from 'rxjs';

declare var $: any;

@Component({
    selector: 'app-recherche-multiple',
    templateUrl: './recherche-multiple.component.html',
    styleUrls: ['./recherche-multiple.component.css'],
    standalone: false
})
export class RechercheMultipleComponent implements OnInit, OnChanges {
  @Input() placeholder: string;
  @Input() dataSource: any[];
  @Input() results: any[];
  @Input() label: string;
  @Input() defaultsearch: string;
  @Input() id: string;
  @Input() prefixid: string;
  @Input() notOblig: boolean;
  @Input() active: boolean;
  @Input() minlength: number;
  @Input() othersearch: boolean;
  @Input() filtre: any[];
  @Input() isclient: boolean;
  @Input() showVille: boolean;
  @Input() afficherPrenom: boolean;
  @Input() setfiltre = [];
  @Input() listeChoix = [];
  @Input() type: number;
  @Input() ispayement: boolean;
  @Input() changerNomChauffeur: boolean;
  @Input() afficherClientToutProspect: boolean;
  @Input() afficherFactureAvoirNonHistorise: boolean;
  @Input() afficherFactureAvoirNonHistoriseEtNonImprimee: boolean;
  @Input() afficherFactureAvoirHistorise: boolean;
  @Input() rechercherChauffeurAssignePartiel: boolean;
  @Input() dateDebut: boolean;
  @Input() dateFin: boolean;
  @Input() miltiple: boolean;
  @Input() afficherBonAFacturer: boolean;
  @Input() afficherBonEnCreation: boolean;
  @Input() afficherBonHistorise: boolean;
  @Input() isSearchEcoportail: boolean;
  @Input() isSearchBAK: boolean;
  @Input() isNotAll: boolean;
  @Input() isADV: boolean;
  @Input() isHistoADV: boolean;
  @Input() isContrat: boolean;
  @Input() isHistoContrat: boolean;
  @Input() rechercherEnseigneClient: boolean;
  @Input() ecodechet: boolean;
  @Input() retourBon: boolean;
  @Input() searchModel;
  @Input() isclefTypeInterimaire;
  @Input() removeFiltreIfTableNoExit;
  @Input() clefTypeInterimaireChauffeur;
  @Input() afficherChauffeurSite: boolean;
  @Input() notloadoninit: boolean;
  @Input() rechercherChauffeurParCodeAnalytique: boolean;
  @Input() disableFocusAuto: boolean;
  @Input() afficherDevisHistorise: boolean;
  @Input() affichageParMaterielEcoloc: boolean;
  @Input() mapParamServlet: any;
  @Input() disableRecherche: boolean;
  @Input() notDefautFiltre: boolean;
  @Input() isRechercherVehiculeClient: boolean;
  @Input() isRechercheChantierDemande: boolean;
  @Input() isRechercheFicheDetenteur: boolean;
  @Input() ajouterItemChantierContenantTexte: boolean;
  @Input() searchTypeDate: boolean;
  @Input() chercherDansTousLesSites: boolean;
  @Input() afficheMessagePreciserRecherche: boolean;
  @Input() nbrCaractere: boolean;
  @Input() afficherDateNaissance: boolean;
  @Input() activeDelaiRecherche: boolean;
  @Input() afficherSiret: boolean;
  @Input() clefTypeContrat: 0;

  @Output() searchfunction = new EventEmitter<String>();

  @Output() selectfunction = new EventEmitter<any>();
  @Output() keyenterfunction = new EventEmitter<String>();
  @Output() isopen = new EventEmitter<Boolean>();
  @Output() setdefaultfiltre = new EventEmitter<any>();
  status: { isopen: boolean } = { isopen: false };
  plhd: String = '';
  isFocus: Boolean = false;
  isLoading: Boolean = false;
  isMessagePreciserRecherche: Boolean = false;
  search: String = '';
  searchExe: String = '';
  selected: any = {};
  listeFiltre = [];
  delay;
  user: any = {};
  error = '';
  societe
  listFiltreIndex = [];
  indexAppel = 0
  @ViewChild('msg') msg;
  doSomethingAfterSearch


  constructor(protected common: CommonService, private modalService: BsModalService) {
    this.doSomethingAfterSearch = new BehaviorSubject<any>(null);
    this.doSomethingAfterSearch.subscribe(data => {
      console.log(data, this.search)
      if (data && data !== this.search) {
        console.log('recherche après : ', data, this.search)
        this.searchelement(this.search)
      } else {
        console.log('Pas de recherche après');
        this.isLoading = false;
      }
    });
  }

  ngOnInit() {
    this.plhd = this.placeholder;
    this.selected = this.search.length ? this.results[0] : {};
    this.search = this.defaultsearch || '';
    this.minlength = this.minlength || 1;
    this.results = this.results || [];
    this.filtre = this.filtre || [];
    this.filtre.forEach(elt => this.listFiltreIndex.push(elt));
    console.log(this.listFiltreIndex)
    this.afficherClientToutProspect = this.afficherClientToutProspect || false;
    this.afficherFactureAvoirNonHistorise = this.afficherFactureAvoirNonHistorise || false;
    this.afficherFactureAvoirNonHistoriseEtNonImprimee = this.afficherFactureAvoirNonHistoriseEtNonImprimee || false;
    this.afficherFactureAvoirHistorise = this.afficherFactureAvoirHistorise || false;
    this.ispayement = this.ispayement || false;
    this.isSearchEcoportail = this.isSearchEcoportail || false;
    this.chercherDansTousLesSites = this.chercherDansTousLesSites || false;
    if (this.isSearchEcoportail) {
      this.user = this.common.local.getObject('clientLogin') || {};
      const stylePageEcoportail = this.common.local.getObject('stylePageEcoportail') || {};
      this.user['couleur'] = this.user['couleur'] !== '' ? this.user['couleur'] : stylePageEcoportail.couleur;
    }
    const splitUrl = window.location.href.split('/');
    this.prefixid = this.prefixid || ('recherche_' + splitUrl.pop());


    setTimeout(() => {
      if (!this.disableRecherche) {
        $('#searchElem').focus();
      }
    }, 500);

    if (!this.notDefautFiltre) {
      switch (this.type) {
        case 1:
          this.listeFiltre = this.common.filtrePlanning;
          this.load();
          break;
        case 2:
          this.listeFiltre = this.common.filtreValidation;
          this.load();
          break;
        case 3:
          this.listeFiltre = this.common.filtreFact;
          this.load();
          break;
        case 4:
          this.listeFiltre = this.common.filtreBenne;
          this.load();
          break;
        case 5:
          this.listeFiltre = this.common.filtreFacture;
          this.load();
          break;
        case 6:
          this.listeFiltre = this.common.filtreBonachat;
          this.load();
          break;
        case 7:
          this.listeFiltre = this.common.filtreCompta;
          this.load();
          break;
        case 8:
          this.listeFiltre = this.common.filtreDevis;
          this.load();
          break;
        case 9:
          this.listeFiltre = this.common.filtreDevisDupliquerClient;
          this.load();
          break;
        case 10:
          this.listeFiltre = this.common.filtreRelanceFact;
          this.load();
          break;
        case 11:
          this.listeFiltre = this.common.filtrePaiement;
          this.load();
          break;
        case 12:
          this.listeFiltre = this.common.filtreRelancedevis;
          this.load();
          break;
        case 13:
          this.listeFiltre = this.common.filtreContenant;
          this.load();
          break;
        case 14:
          this.listeFiltre = this.common.filtreRetourbon;
          this.load();
          break;
        case 15:
          this.listeFiltre = this.common.filtreRDV;
          this.load();
          break;
        case 16:
          this.listeFiltre = this.common.filtreDetenteur;
          this.load();
          break;
        case 17:
          this.listeFiltre = this.common.filtreProforma;
          this.load();
          break;
        case 18:
          this.listeFiltre = this.common.filtreContrat;
          this.load();
          break;
        case 19:
          this.listeFiltre = this.common.filtrePrestation;
          this.load();
          break;
        case 20:
          this.listeFiltre = this.common.filtrePrestationHisto;
          this.load();
          break;
        case 21:
          this.listeFiltre = this.common.filtreChantier;
          this.load();
          break;
        case 22:
          this.listeFiltre = this.common.filtreTournee;
          this.load();
          break;
        case 23:
          this.listeFiltre = this.common.filtreDemandes;
          this.load();
          break;
        case 24:
          this.listeFiltre = this.common.filtreBAK;
          this.load();
          break;
        case 25:
          this.listeFiltre = this.common.filtreClient;
          this.load();
          break;
        case 26:
          this.listeFiltre = this.common.filtreStockBac;
          this.load();
          break;
        case 27:
          this.listeFiltre = this.common.filtreValidationBac;
          this.load();
          break;
        case 28:
          this.listeFiltre = this.common.filtreEntrees;
          this.load();
          break;
        case 29:
          this.listeFiltre = this.common.filtreSorties;
          this.load();
          break;
        case 30:
          this.listeFiltre = this.common.filtreHistoRetourBon;
          this.load();
          break;
        case 31:
          this.listeFiltre = this.common.filtreBAP;
          this.load();
          break;
        case 32:
          this.listeFiltre = this.common.filtrePlanningRH;
          this.load();
          break;
        case 33:
          this.listeFiltre = this.common.filtreHeures;
          this.load();
          break;
        case 34:
          this.listeFiltre = this.common.filtreAppro;
          this.load();
          break;
        case 35:
          this.listeFiltre = this.common.filtreExpedition;
          this.load();
          break;
        case 36:
          this.listeFiltre = this.common.filtreStockEcostock;
          this.load();
          break;
        case 37:
          this.listeFiltre = this.common.filtreExpeditionEcodd;
          this.load();
          break;
        case 38:
          this.listeFiltre = [];
          this.load();
          break;
        case 40:
          this.listeFiltre = this.common.filtreValidationEcogar;
          this.load();
          break;
        case 39:
          this.listeFiltre = this.common.filtrePlanningEcogar;
          this.load();
          break;
        case 41:
          this.listeFiltre = this.common.filtreParcentretienEcogar;
          this.load();
          break;
        case 42:
          this.listeFiltre = this.common.filtreValidationEcogarHistoKm;
          this.load();
          break;
        case 43:
          this.listeFiltre = this.common.filtreEcotri;
          this.load();
          break;
        case 44:
          this.listeFiltre = this.common.filtreEcotriSortie;
          this.load();
          break;
        case 45:
          this.listeFiltre = this.common.filtreEcodecVHU;
          this.load();
          break;
        case 46:
          this.listeFiltre = this.common.filtreBonCommande;
          this.load();
          break;
        case 47:
          this.listeFiltre = this.common.filtreRegistreEntree;
          this.load();
          break;
        case 48:
          this.listeFiltre = this.common.filtreHistoriqueExpe;
          this.load();
          break;
        case 49:
          this.listeFiltre = this.common.filtreRegistreSortie;
          this.load();
          break;
        case 50:
          this.listeFiltre = this.common.filtreHistoBAP;
          this.load();
          break;
        case 51:
          this.listeFiltre = this.common.filtreFIP;
          this.load();
          break;
        case 52:
          this.listeFiltre = this.common.filtreCAP;
          this.load();
          break;
        case 53:
          this.listeFiltre = this.common.filtreUsager;
          this.load();
          break;
      }
    }

  }

  ngOnChanges(changes) {
    if (this.listeChoix) {
      this.listeFiltre = this.listeChoix;
    }

    if (this.filtre) {
      this.filtre = this.filtre;
    }
  }

  load() {
    if (!this.notloadoninit) {
      if (this.listeFiltre.length) {
        this.results = [];
        if (this.removeFiltreIfTableNoExit) {
          this.listeFiltre.forEach(elt => {
            if ((elt.table === "clients") || (elt.table === "chantiers") || (elt.table === "all")) {
            } else {
              this.listeFiltre = [];
            }
          })
        }
        this.selectfunction.emit(this.listeFiltre);
        this.listeFiltre.forEach(item => {
          if (this.miltiple) {
            // item.table !== 'clients' && 
            if (item.table !== 'chauffeurs' && item.table !== 'chauffeurLocationMateriel') {
              this.filtre = this.filtre.filter(elt => elt !== item.table);
            }
          } else {
            this.filtre = this.filtre.filter(elt => elt !== item.table);
          }
          // this.filtre = this.filtre.filter(elt => elt !== item.table);
        });
      }
    }

  }

  searchelement(event) {
    if (this.filtre.length) {
      this.defaultFunction(event);
    } else {
      this.status.isopen = false;
    }
  }

  defaultFunction(event, btn?) {
    const minlength = btn ? 1 : this.minlength;
    this.societe = this.common.local.getObject('paramSociete') || {};
    if (this.search.length >= minlength) {
      if (!this.status.isopen) {
        this.toggleDropdown(event);
      }
      if (this.isSearchBAK) {
        this.searchBak(this.search);
      } else {
        this.searchFct(this.search, btn);
      }
    }
    if (this.search.length < minlength) {
      this.status.isopen = false;
      this.isLoading = false;
      this.results = [];
    }
  }

  searchByBtn(event) {
    this.defaultFunction(event, true);
  }

  toggleDropdown($event?: MouseEvent): void {
    this.status.isopen = !this.status.isopen;
    this.isopen.emit(this.status.isopen);
  }

  change(value: boolean): void {
    this.status.isopen = value;
  }

  defaultFocus(event) {
    if ((event.keyCode === 40)) {
      $('[tabindex=0]').focus();
      this.selected = this.results[0];
      event.preventDefault();
      event.stopPropagation();
    }
    if ((event.keyCode === 38)) {
      $('[tabindex=0]').focus();
      this.selected = this.results[0];
      event.preventDefault();
      event.stopPropagation();
    }
    if (this.search.length === 0) {
      if ((event.keyCode === 8)) {
        const index = this.listeFiltre.length - 1;
        this.deleteFilter(index, this.listeFiltre[index]);
      }
    }
  }

  changeFocus(event, i) {
    if ((event.keyCode === 40) && event.target.nextElementSibling) {
      event.target.nextElementSibling.focus();
      this.selected = this.results[i + 1];
    }
    if ((event.keyCode === 38) && event.target.previousElementSibling) {
      this.selected = this.results[i - 1];
      event.target.previousElementSibling.focus();
    }
  }

  widthInput() {
    let taille;
    let length = 0;
    if (this.listeFiltre.length) {
      this.listeFiltre.forEach(elt => {
        length += (elt.libelleObjetEntite.length);
      });
      if (this.listeFiltre.length >= 4) {
        return 'auto';
      } else {
        if (length > 8) {
          taille = 138 * this.listeFiltre.length;
        } else {
          taille = 130 * this.listeFiltre.length;
        }
        return 'calc(100% - ' + (taille + 25) + 'px)';
      }

      // return 'auto';
    } else {
      return 'calc(100% - 48px)';
    }
  }

  searchFct(event, btn?) {
    clearTimeout(this.delay);
    const ctrl = this;
    let delairecherche = 700
    const minlength = btn ? 1 : this.minlength;

    if (ctrl.societe["clientCollectivite"] && ctrl.activeDelaiRecherche) {
      const userDetail = this.common.local.getObject('userDetail');
      delairecherche = userDetail['delaiRecherche'] || 700
    }

    this.delay = setTimeout(() => {
      ctrl.results = [];
      if (!ctrl.isLoading) {
        ctrl.isLoading = true;
        if (ctrl.isSearchEcoportail) {
          const user = ctrl.common.local.getObject('clientLogin') || {};
          const url = `${ctrl.common.reformeNomClient(user['nom'])}/datatram/get/chantiers/${user.clefClient}/${event}`;
          ctrl.common.getEcoportail(url).then(datas => {
            $('#searchElem').click();
            if (datas) {
              datas.forEach(elt => {
                elt.type = 'Détenteur';
                elt.libelleObjetEntite = elt.siteNumber;
              });
              ctrl.results = datas;
              ctrl.doSomethingAfterSearch.next(event)
            }
            ctrl.isLoading = false;
          }).catch(error => {
            ctrl.doSomethingAfterSearch.next(event)
            ctrl.isLoading = false;
            if (error.message && error.message.includes('Utilisateur non-autentifié ou la session a expiré')) {
              ctrl.common.logoutEcoportail();
            } else {
              console.log(error);
            }
          });
        } else {
          // Do the ajax stuff
          let filtre = [];
          if (ctrl.isADV) {
            ctrl.filtre.forEach(elt => {
              if (elt === 'bon') {
                elt = ctrl.isHistoADV ? 'bonADVHisto' : 'bonADV'
                console.log(elt)
                filtre.push(elt);
              } else {
                filtre.push(elt);
              }
            });
          } else {
            if (ctrl.isContrat) {
              ctrl.filtre.forEach(elt => {
                if (elt === 'contrat') {
                  elt = ctrl.isHistoContrat ? 'contratSolde' : 'contratNonSolde'
                  console.log(elt)
                  filtre.push(elt);
                } else {
                  filtre.push(elt);
                }
              });
            } else {
              filtre = ctrl.filtre;
            }
          }

          ctrl.common.getModule();
          const activedModule = '' + ctrl.common.activedModule;

          // if (ctrl.common.activedModule === 1 || ctrl.common.activedModule === 2 ||
          //   ctrl.common.activedModule === 3 || ctrl.common.activedModule === 4) {
          //   ctrl.afficherPrenom = true;
          // }

          ctrl.afficherPrenom = true;
          const user = ctrl.common.local.getObject('userDetail') || {};
          const fonctionUser = user.fonctionUser ? (user.fonctionUser.id || 0) : 0;
          ctrl.indexAppel++;
          const last_click = ctrl.indexAppel;
          let search = event;
          let model;

          if (ctrl.isValidDate(search)) {
            console.log('valide DD/MM/YYYY')
            search = moment(search, 'DD/MM/YYYY').format('YYYY-MM-DD');
          } else {
            if (ctrl.isValidMMYYYY(search)) {
              search = moment(search, 'MM/YYYY').format('YYYY-MM');
            } else {
              if (ctrl.isValidDDMM(search)) {
                search = moment(search, 'DD/MM').format('MM-DD');
              }
              if (ctrl.searchTypeDate) {
                if (search && typeof search === 'string') {
                  const DDMMYYYY = search.match(/^(0?[1-9]|[12][0-9]|3[01])[\/\-\.](0?[1-9]|1[012])[\/\-\.]\d{4}$/) ? true : false;
                  if (DDMMYYYY) {
                    model = moment(search, 'DD/MM/YYYY').format('DD/MM/YYYY');
                    if (model) {
                      search = model;
                    }
                  }
                  else {
                    if (search && search.length === 6) {
                      if (!search.includes('/') && moment(search, 'DDMMYY').isValid()) {
                        model = moment(search, 'DDMMYY').format('DD/MM/YYYY');
                        console.log(model, moment(search, 'DDMMYY').format('DD/MM/YYYY'));
                        if (model) {
                          search = model
                        }
                      }
                    } else {
                      if (search && search.length === 8) {
                        if (!search.includes('/') && moment(search, 'DDMMYYYY').isValid()) {
                          model = moment(search, 'DDMMYYYY').format('DD/MM/YYYY');
                          console.log(model, moment(search, 'DDMMYYYY').format('DD/MM/YYYY'))
                          if (model) {
                            search = model
                          }
                        } else if (moment(search, 'DD/MM/YY').isValid()) {
                          model = moment(search, 'DD/MM/YY').format('DD/MM/YYYY');
                          console.log(model, moment(search, 'DD/MM/YY').format('DD/MM/YYYY'))
                          if (model) {
                            search = model
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }

          const isEnseigne = ctrl.listeFiltre.filter(elt => elt.table === 'enseigne');
          const isClient = ctrl.listeFiltre.filter(elt => elt.table === 'clients' || elt.table === 'enseigneClient');
          const isAgence = ctrl.listeFiltre.filter(elt => elt.table === 'Agence' || elt.table === 'agence');
          const isChantier = ctrl.listeFiltre.filter(elt => elt.table === 'chantiers');

          console.log(search)
          ctrl.searchModel = search;
          const param = {
            'critere': search,
            'type': filtre,
            'afficherCodeNomClient': ctrl.isclient || 'false',
            'afficherPrenom': ctrl.afficherPrenom || 'false',
            'rechercherEnseigneClient': ctrl.rechercherEnseigneClient || 'false',
            'isRechercherVehiculeClient': ctrl.isRechercherVehiculeClient || 'false',
            'afficherBonAFacturer': ctrl.afficherBonAFacturer || 'false',
            'afficherBonEnCreation': ctrl.afficherBonEnCreation || 'false',
            'afficherBonHistorise': ctrl.afficherBonHistorise || 'false',
            'afficherChauffeurSite': ctrl.afficherChauffeurSite || 'false',
            'rechercherChauffeurParCodeAnalytique': 'false',
            'afficherClientToutProspect': ctrl.afficherClientToutProspect,
            'afficherFactureAvoirNonHistorise': ctrl.afficherFactureAvoirNonHistorise,
            'afficherFactureAvoirNonHistoriseEtNonImprimee': ctrl.afficherFactureAvoirNonHistoriseEtNonImprimee,
            'afficherFactureAvoirHistorise': ctrl.afficherFactureAvoirHistorise,
            'afficherDevisHistorise': ctrl.afficherDevisHistorise,
            'clefSite': ctrl.common.user[2],
            'clefUser': ctrl.common.user[0],
            'clefFonction': fonctionUser,
            'clefModule': activedModule,
            'rechercheChantierDemande': ctrl.isRechercheChantierDemande || 'false',
            'rechercheFicheDetenteur': ctrl.isRechercheFicheDetenteur || 'false',
            'ajouterItemChantierContenantTexte': 'false',
            'rechercherChauffeurAssignePartiel': ctrl.rechercherChauffeurAssignePartiel || 'false',
            'afficherDateNaissance': ctrl.afficherDateNaissance || 'false',
            'afficherSiret': ctrl.afficherSiret || 'false',
            'clefTypeContrat': ctrl.clefTypeContrat || 0
          };

          if (ctrl.isclefTypeInterimaire) {
            param['clefTypeInterimaireChauffeur'] = 0
          }

          if (ctrl.clefTypeInterimaireChauffeur) {
            param['clefTypeInterimaireChauffeur'] = ctrl.clefTypeInterimaireChauffeur;
          }

          if (ctrl.mapParamServlet) {
            param['mapParamServlet'] = ctrl.mapParamServlet;
          }

          if (ctrl.rechercherChauffeurAssignePartiel) {
            param['dateDebut'] = ctrl.dateDebut;
            param['dateFin'] = ctrl.dateFin;
          }

          if (ctrl.common.activedModule === 1 ||
            ctrl.common.activedModule === 2 ||
            ctrl.common.activedModule === 3 ||
            ctrl.common.activedModule === 9) {
            param['afficherClientDansChantier'] = true;
          }

          if (ctrl.common.activedModule === 4 || ctrl.showVille) {
            param['afficherVilleClient'] = true;
          }
          ctrl.societe = ctrl.common.local.getObject('paramSociete');
          const isChantierParSite = ctrl.societe.chantierParSite || false;
          if (ctrl.type == 13 && isChantierParSite) {
            param['afficherChantierParSite'] = true;
          }

          if (isChantierParSite && (ctrl.type == 28 || ctrl.type == 29)) {
            param['afficherChantierParSite'] = true;
          }

          if (isEnseigne && isEnseigne.length) {
            const enseigne = isEnseigne[0];
            param['enseigne'] = '' + (enseigne['libelleObjetEntite'] || '');
            filtre = filtre.filter(elt => elt !== 'enseigne');
          }

          if (isClient && isClient.length) {
            const client = isClient[0];
            param['clefClient'] = '' + (client['id'] || 0);
            filtre = filtre.filter(elt => elt !== 'enseigne' && (elt !== 'clients' && elt !== 'enseigneClient'));
            // if (!ctrl.miltiple) {
            //   param['clefClient'] = '' + (client['id'] || 0);
            //   filtre = filtre.filter(elt => elt !== 'enseigne' && (elt !== 'clients' && elt !== 'enseigneClient'));
            // } else {
            //   param['clefClients'] = '';
            //   isClient.forEach(e => {
            //     param['clefClients'] = param['clefClients'] !== '' ? param['clefClients'] + ',' + (e['id'] || 0) :
            //       (param['clefClients'] + (e['id'] || 0));
            //   })
            //   filtre = filtre.filter(elt => elt !== 'enseigne');
            // }
            param['ajouterItemChantierContenantTexte'] = ctrl.ajouterItemChantierContenantTexte ? 'true' : 'false';
          }

          if (isAgence && isAgence.length) {
            const agence = isAgence[0];
            param['clefAgence'] = '' + (agence['id'] || 0);
            filtre = filtre.filter(elt => elt !== 'enseigne' && elt !== 'clients' && elt !== 'Agence' && elt !== 'agence');
            // if (!ctrl.miltiple) {
            //   filtre = filtre.filter(elt => elt !== 'enseigne' && elt !== 'clients' && elt !== 'Agence' && elt !== 'agence');
            // } else {
            //   filtre = filtre.filter(elt => elt !== 'enseigne' && elt !== 'Agence' && elt !== 'agence');
            // }
          }

          if (isChantier && isChantier.length) {
            filtre = filtre.filter(elt => elt !== 'enseigne' && elt !== 'clients' &&
              elt !== 'Agence' && elt !== 'agence' && elt !== 'chantiers');
            // if (!ctrl.miltiple) {
            //   filtre = filtre.filter(elt => elt !== 'enseigne' && elt !== 'clients' &&
            //     elt !== 'Agence' && elt !== 'agence' && elt !== 'chantiers');
            // } else {
            //   filtre = filtre.filter(elt => elt !== 'enseigne' &&
            //     elt !== 'Agence' && elt !== 'agence' && elt !== 'chantiers');
            // }
          }

          param['type'] = filtre;
          if (ctrl.chercherDansTousLesSites) {
            param['chercherDansTousLesSites'] = ctrl.chercherDansTousLesSites;
          }
          if (ctrl.search && (ctrl.search.length >= minlength)) {
            ctrl.common.searchEcoloc({ param: param }).then(datas => {
              $('#searchElem').click();
              ctrl.isLoading = false;
              if (datas.data && (last_click === ctrl.indexAppel)) {
                ctrl.isMessagePreciserRecherche = false;
                datas.data = datas.data || [];
                if (ctrl.afficheMessagePreciserRecherche && search && search.length < ctrl.nbrCaractere) {
                  const result = ctrl.groupBy(datas.data, (c) => c.table);
                  let plus50 = false;
                  for (let key in result) {
                    if (key && !plus50) {
                      plus50 = result[key] && result[key].length === 50 ? true : false;
                    }
                  }
                  ctrl.isMessagePreciserRecherche = plus50;
                }


                datas.data.forEach(elt => {
                  switch (elt.table) {
                    case 'chauffeurs':
                      if (!ctrl.changerNomChauffeur && !ctrl.common.isPrestation) {
                        elt.type = 'Moyen humain';
                      } else {
                        elt.type = 'Partenaire';
                      }

                      break;
                    case 'chauffeurValidationLM':
                      if (!ctrl.changerNomChauffeur && !ctrl.common.isPrestation) {
                        elt.type = 'Moyen humain';
                      } else {
                        elt.type = 'Partenaire';
                      }

                      break;
                    case 'ressourceEcogar':
                      elt.type = 'Moyen humain';
                      break;
                    case 'ChauffeurRessource':
                      elt.type = 'Moyen humain';
                      break;
                    case 'ressourceEcogarHisto':
                      elt.type = 'Moyen humain';
                      break;
                    case 'chauffeurMouvement':
                      elt.type = 'Moyen humain';

                      break;
                    case 'chauffeurLocationMateriel':
                      elt.type = 'Moyen humain';

                      break;
                    case 'clients':

                      if (ctrl.ispayement) {
                        if (ctrl.common.paramPaiement['isBonAchat']) {
                          elt.type = 'Fournisseur';
                        } else {
                          elt.type = 'Client';
                        }
                        elt.order = 1;
                      } else {
                        elt.type = 'Client';
                      }
                      break;
                    case 'Agence':
                      elt.type = 'Agence';
                      break;
                    case 'enseigne':
                      elt.type = 'Enseigne';
                      break;
                    case 'enseigneClient':
                      elt.type = 'Enseigne';
                      break;
                    case 'agence':
                      elt.type = 'Agence';
                      break;
                    case 'article':
                      elt.type = 'Article';
                      break;
                    case 'chantiers':
                      elt.type = 'Chantier';
                      break;
                    case 'contrat':
                      elt.type = 'N° de contrat';
                      break;
                    case 'contratNonSolde':
                      elt.type = 'N° de contrat';
                      break;
                    case 'contratSolde':
                      elt.type = 'N° de contrat';
                      break;
                    case 'serviceUsers':
                      elt.type = 'Service';
                      break;
                    case 'serviceUserLocationMateriel':
                      elt.type = 'Service';
                      break;
                    case 'camions':
                      elt.type = 'Camions';
                      break;
                    case 'bon':
                      elt.type = 'Bon';
                      break;
                    case 'bonEcoloc':
                      elt.type = 'Bon';
                      break;
                    case 'bonADVHisto':
                      elt.type = 'Bon';
                      elt.table = 'bon';
                      break;
                    case 'bonADV':
                      elt.type = 'Bon';
                      elt.table = 'bon';
                      break;
                    case 'bonEcodechetEntree':
                      elt.type = 'Bon';
                      break;
                    case 'bonEcodechetSortie':
                      elt.type = 'Bon';
                      break;
                    case 'bonAchatParticulier':
                      elt.type = 'Bon';
                      break;
                    case 'bonAchatParticulierPaiement':
                      elt.type = 'Bon';
                      break;
                    case 'bonRdbEcobennes':
                      elt.type = 'Bon';
                      break;
                    case 'parking':
                      elt.type = 'Parking';
                      break;
                    case 'facture':
                      elt.type = 'Facture';
                      if (ctrl.ispayement) {
                        elt.order = 2;
                      }
                      ctrl.isMontant(datas.data, elt);
                      break;

                    case 'avoir':
                      elt.type = 'Avoir';
                      if (ctrl.ispayement) {
                        elt.order = 3;
                      }
                      ctrl.isMontant(datas.data, elt);
                      break;

                    case 'bonAchat':
                      elt.type = 'Bon d\'achat';
                      if (ctrl.ispayement) {
                        elt.order = 2;
                      }
                      ctrl.isMontant(datas.data, elt);
                      break;
                    case 'avoirAchat':
                      elt.type = 'Avoir sur achat';
                      if (ctrl.ispayement) {
                        elt.order = 3;
                      }
                      ctrl.isMontant(datas.data, elt);
                      break;
                    case 'chantiers_clients':
                      elt.type = 'Détenteur';
                      break;
                    case 'tournee':
                      elt.type = 'Tournée';
                      break;
                    case 'fournisseurs':
                      elt.type = 'Fournisseur';
                      break;
                    case 'typeContenant':
                      elt.type = 'Type contenant';
                      break;
                    case 'zone':
                      elt.type = 'Zone';
                      break;
                    case 'dateMouvementCourant':
                      elt.type = 'Date';
                      break;
                    case 'critereVHU':
                      elt.type = 'VHU';
                      break;
                    case 'users':
                      elt.type = 'Commercial';
                      break;
                    case 'article_tous':
                      elt.type = 'Article';
                      break;
                    case 'typeArticle':
                      elt.type = 'Famille d\'article';
                      break;
                    case 'expeditionDDNonValidee':
                      elt.type = 'Expédition';
                      break;
                    case 'expeditionDDValidee':
                      elt.type = 'Expédition';
                      break;
                    case 'emplacementStock':
                      elt.type = 'Emplacement';
                      break;
                    case 'articleDD':
                      elt.type = 'Article';
                      break;
                    case 'contenantDDManuel':
                      elt.type = 'Contenant';
                      break;
                    case 'contenantDD':
                      elt.type = 'Contenant';
                      break;
                    case 'typeCamionEcogar':
                      elt.type = 'Type matériel';
                      break;
                    case 'typeBenneEcogar':
                      elt.type = 'Famille contenant';
                      break;
                    case 'prospectHolding':
                      elt.type = 'Prospect';
                      break;
                    case 'siteUser':
                      elt.type = 'Site';
                      break;
                    case 'camionEcogar':
                      elt.type = 'Matériel';
                      break;
                    case 'camionPlanningEcoloc':
                      elt.type = 'Matériel';
                      break;
                    case 'Exutoire':
                      elt.type = 'Exutoire';
                      break;
                    case 'bonEcotriEntree':
                      elt.type = 'Bon';
                      break;
                    case 'bonEcotriSortie':
                      elt.type = 'Bon';
                      break;
                    case 'bonPrestationSI':
                      elt.type = 'Bon';
                      break;
                    case 'codeAnalytiqueRH':
                      elt.type = 'Code analytique';
                      break;
                    case 'axeAnalytiqueChauffeurs':
                      elt.type = 'Code analytique';
                      break;
                    case 'devis':
                      elt.type = 'Devis';
                      break;
                    case 'chantierEcobac':
                      elt.type = 'Détenteur';
                      break;
                    case 'adresseEcobac':
                      elt.type = 'Adresse';
                      break;
                    case 'villeEcobac':
                      elt.type = 'Ville';
                      break;
                    case 'numeroBacEcobac':
                      elt.type = 'Numéro de bac';
                      break;
                    case 'numeroBacEcobacEnStock':
                      elt.type = 'Numéro de bac (stock)';
                      break;
                    case 'clientEcobac':
                      elt.type = 'Client';
                      break;
                    case 'contratValidationLM':
                      elt.type = 'Contrat';
                      break;
                    case 'dateValidationLM':
                      elt.type = 'Date';
                      break;
                    case 'articleStockBenne':
                      elt.type = 'Article';
                      break;
                    case 'typeContenantStockBenne':
                      elt.type = 'Contenant';
                      break;
                    case 'demandeCreationCompte':
                      elt.type = 'Création compte';
                      break;
                    case 'ChantierContenantTexte':
                      elt.type = 'Chantier contenant le texte';
                      break;
                    case 'bonCommandesNonValide':
                      elt.type = 'Bon de commande';
                      break;
                    case 'lieuChantierContenant':
                      elt.type = ctrl.societe.clientCollectivite ? 'Circuit' : 'Lieu chantier';
                      break;
                    case 'anneeFip':
                      elt.type = 'Année';
                      break;
                    case 'anneeCap':
                      elt.type = 'Année';
                      break;
                    case 'userEcoGED':
                      elt.type = 'Usager';
                      break;                      
                  }
                });
                ctrl.results = datas.data;
                if (ctrl.ispayement) {
                  ctrl.results.sort(function (a, b) {
                    if (a.order < b.order) {
                      return -1;
                    }
                    if (a.order > b.order) {
                      return 1;
                    }
                    return 0;
                  });
                }
                ctrl.isLoading = false;
                ctrl.doSomethingAfterSearch.next(event)
              } else {
                ctrl.isLoading = false;
                ctrl.doSomethingAfterSearch.next(event)
                if (datas.message) {
                  if (datas.message.includes('Utilisateur non authentifié')) {
                    ctrl.common.removeConnection();
                  } else {
                    ctrl.error = datas.message;
                    ctrl.common.openModal(ctrl.modalService, ctrl.msg);
                    console.error(datas.message);
                  }
                }
              }
            });
          } else {
            ctrl.isLoading = false;
          }
          if (ctrl.search && (ctrl.search.length < minlength)) {
            ctrl.status.isopen = false;
            ctrl.isLoading = false;
            ctrl.results = [];
          }
        }
      }
    }, delairecherche);
  }


  searchBak(event) {
    clearTimeout(this.delay);
    let delairecherche = 700;
    const ctrl = this;
    if (ctrl.societe["clientCollectivite"] && ctrl.activeDelaiRecherche) {
      const userDetail = this.common.local.getObject('userDetail');
      delairecherche = userDetail['delaiRecherche'] || 700;
    }
    this.delay = setTimeout(() => {
      ctrl.results = [];
      const param = {
        'servlet': 'DBGestionBAKAngular',
        'module': 'Recylog',
        'type': 'map',
        'compression': 'false',
        'data': {
          'OPERATION': {
            'typeParam': 'int',
            'valeur': 6
          },
          'CLEF_USER': {
            'typeParam': 'int',
            'valeur': ctrl.common.user[0]
          },
          'CLEF_SITE': {
            'typeParam': 'int',
            'valeur': ctrl.common.user[2] || 0
          },
          'VILLE': event || '',
        }
      };

      ctrl.common.post('', { param: param }).then(datas => {
        $('#searchElem').click();
        if (datas.data) {
          const table = [];
          datas.data.forEach((elt, index) => {
            table.push({
              type: 'Ville',
              table: 'ville',
              libelleObjetEntite: elt,
              id: index + 1
            });
          });
          ctrl.results = table;
          ctrl.doSomethingAfterSearch.next(event)

        } else {
          ctrl.doSomethingAfterSearch.next(event)
          if (datas.message) {
            if (datas.message.includes('Utilisateur non authentifié')) {
              ctrl.common.removeConnection();
            } else {
              console.error(datas.message);
            }
          }
        }
      });

    }, delairecherche);
  }

  groupBy(xs, f) {
    return xs.reduce((r, v, i, a, k = f(v)) => ((r[k] || (r[k] = [])).push(v), r), {});
  }

  isMontant(data, elt) {
    const libelle = elt.libelleObjetEntite.split('/');
    if (this.ispayement && !libelle[0].includes(this.search) && libelle[1].includes(this.search)) {
      elt.table = 'montant';
      elt.type = 'Montant';
      if (this.ispayement) {
        elt.order = 4;
      }
      elt.libelleObjetEntite = libelle[1] + (libelle[libelle.length - 1] ? ' / ' + libelle[libelle.length - 1] : '');
      // data.push(elt);
    } else {
      elt.libelleObjetEntite = elt.libelleObjetEntite.split('/')[0];
    }
  }

  addFilter(item) {
    if (item) {
      if (this.isclient && item.table === 'clients') {
        const value = item.libelleObjetEntite.split('/');
        item.libelleObjetEntite = value[1];
      }
      this.listeFiltre.push(item);
      this.setdefaultfiltres();
      if (this.miltiple) {
        // item.table !== 'clients' && 
        if (item.table !== 'chauffeurs' && item.table !== 'chauffeurLocationMateriel') {
          this.filtre = this.filtre.filter(elt => elt !== item.table);
        }
      } else {
        this.filtre = this.filtre.filter(elt => elt !== item.table);
      }

      this.search = '';
      this.selectfunction.emit(this.listeFiltre);
      this.status.isopen = false;
      this.isopen.emit(this.status.isopen);
      this.results = [];
      this.selected = {};
      if (!this.disableFocusAuto) {
        $('#searchElem').click();
      }

    }
  }

  valideChoice(item) {
    const ctrl = this
    if (this.results.length) {
      this.addFilter(this.results[0]);
    } else {
      if (!this.isNotAll) {
        if (ctrl.isADV) {
          ctrl.error = "Vous devez saisir au moins un filtre";
          ctrl.common.openModal(ctrl.modalService, ctrl.msg);
        } else {
          const value = { id: 0, libelleObjetEntite: 'Tous', type: 'all', table: 'all' };
          this.addFilter(value);
        }
      }
    }
  }

  deleteFilter(index, elt) {
    this.listeFiltre.splice(index, 1);
    console.log(elt, this.filtre)
    console.log(this.listFiltreIndex);
    const liste = [];
    this.listFiltreIndex.forEach(filtre => liste.push(filtre));
    let existe = this.filtre.filter(elem => elt && elem === elt.table);

    if (elt && !existe.length) {
      this.filtre = [];
      if (elt.table === 'chauffeurs' || elt.table === 'chauffeurLocationMateriel') {
        // this.filtre.unshift(elt.table);
        // this.filtre.splice(this.listFiltreIndex.indexOf(elt.table), 0, elt.table);
        liste.forEach(item => {
          existe = this.listeFiltre.filter(f => f.table === item)
          if (!existe.length) {
            this.filtre.push(item);
          }
        });
      } else {
        if (this.ecodechet) {
          if (elt.table === 'bon') {
            if (this.type === 28) {
              liste.forEach(item => {
                existe = this.listeFiltre.filter(f => f.table === item || (f.table === 'bon' && item === 'bonEcodechetEntree'))
                if (!existe.length) {
                  this.filtre.push(item === 'bon' ? 'bonEcodechetEntree' : item);
                }
              });
            } else {
              liste.forEach(item => {
                existe = this.listeFiltre.filter(f => f.table === item || (f.table === 'bon' && item === 'bonEcodechetSortie'))
                if (!existe.length) {
                  this.filtre.push(item === 'bon' ? 'bonEcodechetSortie' : item);
                }
              });
            }
          } else {
            liste.forEach(item => {
              existe = this.listeFiltre.filter(f => f.table === item)
              if (!existe.length) {
                this.filtre.push(item);
              }
            });
          }
        } else {
          liste.forEach(item => {
            existe = this.listeFiltre.filter(f => f.table === item)
            if (!existe.length) {
              this.filtre.push(item);
            }
          });
        }
      }
    }


    this.search = '';
    this.results = [];
    this.setdefaultfiltres();
    this.selectfunction.emit(this.listeFiltre);
  }

  focusInput() {
    $('#searchElem').focus();
  }

  setdefaultfiltres() {
    this.setdefaultfiltre.emit({ filtre: this.listeFiltre, type: this.type });
  }

  removeFilter() {
    this.listeFiltre.forEach(elt => {
      // const existe = this.filtre.filter(elem => elem === elt.table);
      // if (!existe.length) {
      //   if (elt.table === 'chauffeurs' || elt.table === 'chauffeurLocationMateriel') {
      //     this.filtre.unshift(elt.table);
      //   } else {
      //     this.filtre.push(elt.table);
      //   }
      // }
    });
    this.filtre = [];
    this.listFiltreIndex.forEach(elt => this.filtre.push(elt));
    this.listeFiltre = [];
    this.search = '';
    this.results = [];
    this.setdefaultfiltres();
    this.status.isopen = false;
    this.selectfunction.emit(this.listeFiltre);
  }

  isValidDate(dateString) {
    const regEx = /^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])[\/\-]\d{4}$/;
    return dateString.match(regEx) != null;
  }

  isValidMMYYYY(dateString) {
    const regEx = /^(0?[1-9]|1[012])[\/\-]\d{4}$/;
    return dateString.match(regEx) != null;
  }

  isValidDDMM(dateString) {
    const regEx = /^(0?[1-9]|[12][0-9]|3[01])[\/\-](0?[1-9]|1[012])$/;
    return dateString.match(regEx) != null;
  }


}
